import { Dropdown as SemanticDropdown } from 'semantic-ui-react';

export { DropdownProps, StrictDropdownProps, DropdownOnSearchChangeData } from 'semantic-ui-react';

export const Dropdown: typeof SemanticDropdown = SemanticDropdown;

export default Dropdown;
